/* istanbul ignore file */
import React from 'react';
import { useParams } from 'react-router-dom';
import { DeleteButton } from 'framework/ui/ui-builder';
import { useProjectService, DELETE_PROJECT, useProjectUrl } from 'domain/shared/project';

const deleteMessage = 'Do you really want to delete this project?';

const DeleteProjectButton = () => {
  const { id: projectId } = useParams<Dictionary<string>>();
  const { deleteById } = useProjectService();
  const { getListUrl } = useProjectUrl();

  return (
    <DeleteButton
      deleteMethod={() => deleteById(projectId!)}
      displayMessage={deleteMessage}
      afterDelete={{
        redirectUrl: getListUrl(),
        successMessage: 'The Project has been successfully deleted.',
        errorMessage: `Can't delete project`,
      }}
      permissionToCheck={DELETE_PROJECT}
    />
  );
};

export default DeleteProjectButton;
